import vmClient from '../../services/vmClient';
import { IExternalAssociation } from '../../types/entity';
import { LessonHeader } from './LessonHeader';

export const CourseLessonHeaders: IExternalAssociation = vmClient.defineExternalAssociation({
  typeName: 'CourseLessonHeaders',
  associationType: LessonHeader,
});
